import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { PaginationState } from "@tanstack/react-table";

export function useTableControl(props?: { initialPageSize?: number }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: Number(searchParams.get("page")) || 0,
    pageSize: Number(searchParams.get("size")) || props?.initialPageSize || 10,
  });

  const [search, setSearch] = useState<string | null>(
    searchParams.get("search") || null,
  );

  useEffect(() => {
    setSearchParams((prev) => {
      prev.set("page", pagination.pageIndex.toString());
      prev.set("size", pagination.pageSize.toString());
      return prev;
    });
  }, [pagination, setSearchParams]);

  useEffect(() => {
    setSearchParams((prev) => {
      if (search) {
        prev.set("search", search);
      } else {
        prev.delete("search");
      }
      return prev;
    });
  }, [search, setSearchParams]);

  return { pagination, setPagination, search, setSearch };
}
